import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import styled from 'styled-components';
import { clearBusses } from '../../components/Bus/actions';
import { clearState } from '../../localStorage';
import Api from '../../services/api';
import { getProp, __ } from '../../utilities';
import { errorAlert } from '../App/actions';
import { MAX_PASSENGERS } from '../App/constants';
import ConnectionForm from '../ConnectionForm';
import { fetchConnectionFromTo } from '../Connections/actions';
import { setParams } from './actions';
import { locale } from '../LocaleProvider';
import CustomForm from './CustomForm';
import { connectionParamsDomainSelector } from './selectors';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.primary};
  height: auto;
  color: #fff;
  padding: ${rem(5)};
  ${({ theme }) => theme.media.sm`
    padding: ${rem(30)};
  `};
`;

const passengers = [];
for (let i = 1; i <= MAX_PASSENGERS; i++) {
  passengers.push({
    value: i,
    label: String(i),
  });
}

class ReservationConnectionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        startDate: moment(),
        endDate: moment().add(1, 'week'),
        ticketType: 'S',
      },
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeQuery = this.changeQuery.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, location: { query } } = this.props;

    const params = this.parseNewParameters(query);

    if (params.startDate) {
      params.startDate = moment(params.startDate);
      if (!params.startDate.isValid()) {
        params.startDate = moment();
      }
    } else {
      params.startDate = moment();
    }

    if (params.endDate) {
      params.endDate = moment(params.endDate);
      if (!params.endDate.isValid()) {
        params.endDate = moment().add(1, 'week');
      }
    } else {
      params.endDate = moment().add(1, 'week');
    }

    if (params.firstWayDate && params.firstWayDate.isValid()) {
      if (params.firstWayDate < moment()) {
        params.startDate = moment().add(1, 'week');
      } else {
        params.startDate = moment(params.firstWayDate).add(1, 'week');
      }
    }

    dispatch(setParams(params));
    this.setState({
      values: params,
    });

    this.searchIfPossible(params);
  }

  parametersSufficientForSearch(params) {
    if (
      params.stationFrom &&
      params.stationTo &&
      params.startDate &&
      params.endDate &&
      params.ticketType
    ) {
      return true;
    }
    return false;
  }

  searchIfPossible(params) {
    const { dispatch } = this.props;
    if (this.parametersSufficientForSearch(params)) {
      clearState();
      this.changeQuery(params);
      dispatch(setParams(params));
      dispatch(fetchConnectionFromTo(params));
    }
  }

  parseNewParameters(query) {
    const validParameters = [
      'stationFrom',
      'stationTo',
      'startDate',
      'endDate',
      'count',
      'ticketType',
      'direct',
      'firstWayDate',
      'ticketId',
    ];

    const params = validParameters.reduce((acc, param) => {
      if (param in query) {
        if (
          param === 'endDate' ||
          param === 'startDate' ||
          param === 'firstWayDate'
        ) {
          return { ...acc, [param]: moment(query[param]) };
        }
        return { ...acc, [param]: query[param] };
      }
      return acc;
    }, {});

    return params;
  }

  handleSubmit() {
    const { values } = this.state;
    const { dispatch } = this.props;
    const endDate = getProp(values, ['endDate']);
    const startDate = getProp(values, ['startDate']);
    const endDateMomentObj = endDate ? moment(endDate) : null;
    const startDateMomentObj = startDate ? moment(startDate) : null;

    if (getProp(values, ['stationFrom']) === '') {
      dispatch(errorAlert(__('Nezadali ste zastávku odchodu!')));
    } else if (getProp(values, ['stationTo']) === '') {
      dispatch(errorAlert(__('Nezadali ste zastávku príchodu!')));
    } else if (!startDateMomentObj || !startDateMomentObj.isValid()) {
      dispatch(errorAlert(__('Zlý formát dátumu prvej cesty!')));
    } else if (
      values.ticketType === 'R' &&
      (!endDateMomentObj || !endDateMomentObj.isValid())
    ) {
      dispatch(errorAlert(__('Zlý formát dátumu druhej cesty!')));
    } else if (
      values.ticketType === 'R' &&
      startDateMomentObj.diff(endDateMomentObj) > 0
    ) {
      dispatch(
        errorAlert(
          __(
            'Zle zadané dátumy. Dátum odchodu musí byť menší ako dátum návratu!',
          ),
        ),
      );
    } else {
      clearState();
      this.changeQuery(values);
      const params = this.parseNewParameters(values);
      this.props.dispatch(setParams(params));
      dispatch(fetchConnectionFromTo(params));
      dispatch(clearBusses());
    }
  }

  changeQuery(obj) {
    this.props.dispatch(
      push(`?${Api.objectToParams({ ...obj, lang: locale.lang })}`),
    );
  }

  handleFormChange(values) {
    this.setState({ values });
    this.searchIfPossible(values);
  }

  render() {
    return (
      <Wrapper>
        <ConnectionForm
          value={this.state.values}
          onChange={this.handleFormChange}
          onSubmit={this.handleSubmit}
          renderCustomForm={props => <CustomForm {...props} />}
        />
      </Wrapper>
    );
  }
}

ReservationConnectionForm.propTypes = {
  connectionParams: PropTypes.shape({
    stationFrom: PropTypes.string,
    stationTo: PropTypes.string,
    count: PropTypes.string,
    ticketType: PropTypes.string,
    direct: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    query: PropTypes.shape({}),
  }).isRequired,
};

ReservationConnectionForm.defaultProps = {};

const mapStateToProps = state => {
  return {
    connectionParams: connectionParamsDomainSelector(state),
  };
};
const FormWithRouter = withRouter(ReservationConnectionForm);
export default connect(mapStateToProps)(FormWithRouter);



// WEBPACK FOOTER //
// ./src/containers/ReservationConnectionForm/index.js